/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchClassifyResponseClassifiersItem0 = typeof SearchClassifyResponseClassifiersItem0[keyof typeof SearchClassifyResponseClassifiersItem0];


export const SearchClassifyResponseClassifiersItem0 = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
